module.exports = "./img/eea086dde287f1ec669289973efed05d.png";